import React from 'react';
import CreateCategoryState from './createCategoryState/CreateCategoryState';
import CreateCategoryControlPanel from './components/CreateCategoryControlPanel/CreateCategoryControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';
// import style from './index.module.scss';

const CreateCategoryPage: React.FC = () => {
	return (
		<CreateCategoryState>
			<CreateCategoryControlPanel />
			<Forms />
			<ModalWindows />
		</CreateCategoryState>
	);
};

export default CreateCategoryPage;
